import { Component, inject, Input, OnInit } from '@angular/core';
import { VendorConfigService } from '@core/services/vendor-source-service.service';
import { TranslateService } from '@ngx-translate/core';
import { VendorSource } from '@shared-features/enums/vendor-source.enum';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  @Input() type: 'symbol' | 'full';
  @Input() size: 'xs' | 'sm' | 'md' | 'lg';
  @Input() customLogo: string;
  
  readonly vendorConfig = inject(VendorConfigService).vendorConfig$.value;
  readonly VendorSource = VendorSource;

  private ratio = 167 / 40;
  private sizeMap = {
    xs: 30,
    sm: 36,
    md: 48,
    lg: 72,
  };
  private urls = {
    symbol: '/assets/images/Logo-icon.svg',
    full: '/assets/images/madar-logo.svg',
  };

  get width(): string {
    const size = this.size || 'md';
    const ratio = this.type === 'symbol' ? 1 : this.ratio;
    return `${Math.round(this.sizeMap[size] * ratio)}px`;
  }

  get height(): string {
    const size = this.size || 'md';
    return `${this.sizeMap[size]}px`;
  }

  get imgSrc(): string {
    if (this.type !== 'symbol') {
      const isArabic = this.translate?.currentLang === 'ar';
      return isArabic ? '/assets/images/madar-logo-ar.svg' : this.urls.full;
    }
    return this.urls[this.type] || this.urls.full;
  }

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}
}
